export default __webpack_public_path__ + "static/media/import-xlsx-example.5450ce4e.xlsx";